<template>
  <div class="agreement-list">
    <div v-for="item in agreementList" :key="item.name" class="_item flex" @click="toAgreementSign(item)">
      <div class="flex">
        <img class="file" src="../../../assets/image/bs-2.0/file.png">
        {{item.name}}
        </div>
      <img class="arrow_right" src="../../../assets/image/bs-2.0/arrow_r.png">
    </div>
  </div>
</template>

<script>
import { agreementList } from '@/utils/constants.js'
import api from "@/utils/api";
export default {
  data() {
    return {
      agreementList,
      userId: ''
    }
  },
  mounted() {
    this.userId = this.$route.query.userId
    this.queryAgreement()
  },
  methods: {
    // 点击去签署协议
    toAgreementSign(data) {
      let name = 'agreementSign'
      let query = {
        ...this.$route.query,
        fileName: data.name
      }
      if (data.justSign) {
        query.justSign = data.justSign
      }
      // 处理一下为0时没有signTrack也是去签署
      if(data.approvalStatus !== undefined && data.signTrack) {
        name = 'agreementSignResult'
      }
      this.$router.push({
        name,
        query
      })
    },
    // 查询用户协议签署状态
    queryAgreement() {
      if(!this.userId){return}
      api.getWebuserAgreementByUserId(this.userId).then(res => {
        const data = res.data;
        if (data.returnCode === "0000" && data.content) {
          // 0-待审核 1-审核通过 2-审核不通过
          this.agreementList[0].approvalStatus = data.content.approvalStatus;
          this.agreementList[0].signTrack = data.content.signTrack;
          // 0-待审核 1-审核通过 2-审核不通过
          this.agreementList[1].approvalStatus = data.content.approvalStatusTwo;
          this.agreementList[1].signTrack = data.content.signTrackTwo;
        }
      });
    },
  }

}
</script>

<style lang="scss" scoped>
.agreement-list {
  padding: 10px 20px;
  .flex {
    display: flex;
    align-items: center;
  }
  ._item {
    justify-content: space-between;
    line-height: 16px;
    padding: 17px 20px;
    margin-bottom: 15px;
    color: #333;
    font-size: 14px;
    background-color: #f9f9f9;
    border-radius: 7px;
    img {
      height: 15px;
    }
    .file {
      margin-right: 15px;
    }
  }
}
</style>